export const BLOG_TITLE_PLACEHOLDER_TEXT = 'Your Blog Post Title Here...';